import React from 'react';

interface AuroraBackgroundProps {
  parallaxOffset?: { x: number; y: number };
}

export const AuroraBackground: React.FC<AuroraBackgroundProps> = ({ parallaxOffset = { x: 0, y: 0 } }) => {
  const auroras = [
    {
      size: 'w-[800px] h-[800px]',
      position: 'top-[-20%] left-[-10%]',
      gradient: 'bg-gradient-to-br from-[hsl(190,100%,30%)] via-[hsl(190,90%,20%)] to-transparent',
      animation: 'animate-aurora-1',
      parallaxStrength: 20,
    },
    {
      size: 'w-[700px] h-[700px]',
      position: 'top-[10%] right-[-15%]',
      gradient: 'bg-gradient-to-bl from-[hsl(190,85%,25%)] via-[hsl(190,75%,18%)] to-transparent',
      animation: 'animate-aurora-2',
      parallaxStrength: 30,
    },
    {
      size: 'w-[600px] h-[600px]',
      position: 'bottom-[-10%] left-[20%]',
      gradient: 'bg-gradient-to-tr from-[hsl(195,80%,22%)] via-[hsl(190,70%,16%)] to-transparent',
      animation: 'animate-aurora-3',
      parallaxStrength: 25,
    },
  ];

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-20">
      {auroras.map((aurora, index) => (
        <div
          key={index}
          className={`absolute rounded-full blur-[150px] ${aurora.size} ${aurora.position} ${aurora.gradient} ${aurora.animation}`}
          style={{
            animationTimingFunction: 'ease-in-out',
            animationIterationCount: 'infinite',
            transform: `translate(${parallaxOffset.x * aurora.parallaxStrength}px, ${parallaxOffset.y * aurora.parallaxStrength * 0.8}px)`,
            transition: 'transform 0.3s ease-out',
          }}
        />
      ))}
    </div>
  );
};
